
(async function () {
    const urlParams = new URLSearchParams(window.location.search);
    const brand = urlParams.get('brand');
    const model = urlParams.get('model');

    if(brand && model) {
        document.querySelector('#model-form').style.display = 'none';
        document.querySelector('#model-page-contents').style.display = 'block';

        const modelString = brand + ' ' + model;

        const myHeaders = new Headers();
        myHeaders.append('x-api-key', '6XHzlHGCFQ96QW6f4uxN44HCpGvXJf2yL7WN5XSg');
        myHeaders.append('Content-Type', 'application/json');

        console.log(brand, model);

        if(brand && model) {
            console.log('Requesting...');

            let response = await fetch(`https://apis.needapart.co.nz/model-search?brand=${brand}&model=${model}`, {
                method: 'GET',
                credentials: 'same-origin',
                redirect: "follow",
                headers: myHeaders,
            }).then(res => res.json())
                .catch(e => console.log(e))
            
            // Is there an exact match?
            // Change this to regex "parts for {brand} {model} "
            if(response.results[0].title.toLowerCase().startsWith(`parts for ${modelString.toLowerCase()} `)) {
                // We've got a decent match
                console.log('Redirecting...');
                window.location = `/collections/${response.results[0].handle}`;
            } else {
                // List matches
                let ul = document.querySelector('#model-list');
                let h = document.querySelector('#parts-finder-status');

                let lis = '';
                for(let i = 0; i < response.results.length; i++) {
                    let model = response.results[i];
                    lis += `<li><a href="/collections/${model.handle}">${model.title}</a></li>`;
                }
                ul.innerHTML = lis;
                h.innerHTML = `We found ${response.results.length} models`;
            }
        }
    } else {
        document.querySelector('#model-page-contents').style.display = 'none';
    }

})();